import { render, staticRenderFns } from "./edicao.vue?vue&type=template&id=125ed333"
import script from "./edicao.vue?vue&type=script&lang=js"
export * from "./edicao.vue?vue&type=script&lang=js"
import style0 from "./edicao.vue?vue&type=style&index=0&id=125ed333&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports